<template>
  <div
    :class="{ 'border-gray-900': isActive }"
    class="bg-white rounded-lg border-2 border-solid cursor-pointer py-4 px-5 text-gray-900 relative"
    @click="$emit('select')"
  >
    <div class="text-black text-sm font-normal">{{ coin.name }}</div>
    <div class="text-black text-4xl font-medium">
      {{ formatPrice(coin.price) }}$
    </div>

    <button @click.stop="$emit('remove')" class="absolute top-0 right-0 p-4">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="h5 w5"
      >
        <path
          d="M15.8335 5.83333L15.1107 15.9521C15.0484 16.8243 14.3227 17.5 13.4483 17.5H6.55203C5.67763 17.5 4.9519 16.8243 4.8896 15.9521L4.16683 5.83333M8.3335 9.16667V14.1667M11.6668 9.16667V14.1667M12.5002 5.83333V3.33333C12.5002 2.8731 12.1271 2.5 11.6668 2.5H8.3335C7.87326 2.5 7.50016 2.8731 7.50016 3.33333V5.83333M3.3335 5.83333H16.6668"
          stroke="#9CA3AF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "CoinCard",
  props: {
    coin: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPrice(price) {
      if (price === "-") return price;
      return price > 1 ? price.toFixed(2) : price.toPrecision(2);
    },
  },
};
</script>
